const imageProxyBase = process.env.REACT_APP_IMAGE_PROXY_BASE?.replace(
  /\/+$/,
  ''
);

export const getAdvertisementImageUrl = (
  source: string,
  size?: number
): string => {
  if (!imageProxyBase) return source;

  const resize = size ? `/rs:fit:${size}:${size}` : '';
  return `${imageProxyBase}${resize}/g:sm/plain/${source}`;
};
